import React, { useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaRupeeSign,
} from "react-icons/fa";
import "./LocationDetails.css";
import { Link, useParams } from "react-router-dom";
import Header from "../Header";
import host from "../../config";
const ChildrensArea = () => {
  const { id } = useParams();
  const [ImagesList, setImagesList] = useState([]);
  console.log(useParams());
  useEffect(() => {
    if (!id) return; // Prevent running if ID is not available

    fetch(`${host}/get-booking-images-by-id`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }), // Correct JSON structure
    })
      .then((response) => response.json())
      .then((res) => {
        setImagesList(res);
        console.log("Fetched Images:", res);
      })
      .catch((error) => console.error("Error fetching images:", error));
  }, [id]);

  const auditoriumPricing = [
    {
      id: 1,
      purpose: "Birthday / Corporate / Marriage Functions",
      rent: 30000,
      deposit: 30000,
      gst: 6300,
      cleaning: 5000,
      total: 71300,
    },
    {
      id: 2,
      purpose: "Government Schools (Cultural Activities)",
      rent: 10000,
      deposit: 20000,
      gst: 2160,
      cleaning: 2000,
      total: 34160,
    },
    {
      id: 3,
      purpose: "Private Schools (Cultural Activities)",
      rent: 30000,
      deposit: 30000,
      gst: 6300,
      cleaning: 5000,
      total: 71300,
    },
  ];

  const theatrePricing = [
    {
      id: 4,
      purpose: "General Public (Theatre)",
      rent: 50000,
      deposit: 30000,
      gst: 10800,
      cleaning: 10000,
      total: 100800,
    },
  ];

  return (
    <div>
      <Header />
      <div className="location-page">
        <div className="hero">
          <Carousel showThumbs={false} autoPlay interval={3000} infiniteLoop>
            {ImagesList.map((item, idx) => (
              <div key={idx} className="carousel-image">
                <img src={item.url} alt={`Children's Area Image ${idx + 1}`} />
                <div className="overlay">
                  <h1>Children's Area</h1>
                  <p>Venue for Kids and Community Events</p>
                </div>
              </div>
            ))}
          </Carousel>
        </div>

        <div className="location-details">
          <h2>About the Venue</h2>
          <p className="line-height">
            <strong>Children's Area</strong>, located in{" "}
            <strong>Vuda Children's Arena, Vizag</strong>, is a venue primarily
            for children's events, educational activities, and community
            gatherings. With a spacious hall and all necessary amenities, this
            venue is perfect for various activities.
          </p>

          <h3>Key Amenities</h3>
          <ul className="amenities-list">
            <li>✅ Spacious Auditorium</li>
            <li>✅ Child-Friendly Facilities</li>
            <li>✅ Air Conditioning</li>
            <li>✅ Good Parking Facilities</li>
          </ul>

          <h3>📌 Venue Pricing Details</h3>

          {/* Auditorium Pricing Section */}
          <h4>Auditorium in Ground Floor (A/c)</h4>
          <div className="pricing-container">
            {auditoriumPricing.map((item) => (
              <div key={item.id} className="pricing-card">
                <h4>{item.purpose}</h4>
                <p>
                  <FaRupeeSign /> Rent per Day:{" "}
                  <strong>{item.rent.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Security Deposit:{" "}
                  <strong>{item.deposit.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> GST (18%):{" "}
                  <strong>{item.gst.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Cleaning Charges:{" "}
                  <strong>{item.cleaning.toLocaleString()}</strong>
                </p>
                <p className="total">
                  <FaRupeeSign />{" "}
                  <strong>Total: {item.total.toLocaleString()}</strong>
                </p>
              </div>
            ))}
          </div>

          {/* Theatre Pricing Section */}
          <h4>Theatre in First Floor (A/c)</h4>
          <div className="pricing-container">
            {theatrePricing.map((item) => (
              <div key={item.id} className="pricing-card">
                <h4>{item.purpose}</h4>
                <p>
                  <FaRupeeSign /> Rent per Day:{" "}
                  <strong>{item.rent.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Security Deposit:{" "}
                  <strong>{item.deposit.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> GST (18%):{" "}
                  <strong>{item.gst.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Cleaning Charges:{" "}
                  <strong>{item.cleaning.toLocaleString()}</strong>
                </p>
                <p className="total">
                  <FaRupeeSign />{" "}
                  <strong>Total: {item.total.toLocaleString()}</strong>
                </p>
              </div>
            ))}
          </div>

          <p className="note">
            <strong>Note:</strong> Additional charges for electricity and
            cleaning may apply.
          </p>

          <h3>📞 Contact Information</h3>
          <div className="contact-info">
            <p>
              <FaMapMarkerAlt /> Location: Vuda Children's Arena, Vizag
            </p>
            <p>
              <FaPhoneAlt /> Phone: +91 98765 43210
            </p>
            <p>
              <FaEnvelope /> Email: info@childrensarea.com
            </p>
          </div>

          <Link to="/" className="book-now-btn">
            Book Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ChildrensArea;
